<template>
    <div class="thumbnail-wrap" :class="`thumbnail-wrap-${mode}`">
        <img v-if="gender ==='man'" class="round-image" :width="width" :height="width" src="./images/touxiang.jpg" alt="thumbnail"/>
        <img v-else class="round-image" :width="width" :height="width" src="./images/woman.jpg" alt="thumbnail"/>
        <div class="thumbnail-text" :style="{ fontSize: fontSize + 'px' }">
            <slot v-if="$slots.default"></slot>
            <template v-else-if="text.length">
                <p v-text="text"></p>
            </template>
        </div>
    </div>
</template>
<script type="text/javascript">
    export default {
        name: 'Thumbnail',
        props: {
            mode: {
                type: String,
                'default': 'vertical' // horizontal,vertical
            },
            width: {
                type: Number,
                'default': 80
            },
            text: {
                type: String,
                'default': ''
            },
            fontSize: {
                type: Number,
                'default': 14
            },
            gender: {
                type: String,
                'default': 'man' // woman
            }
        },
        data () {
            return {}
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .thumbnail-wrap {
        .round-image {
            border-radius : 50%;
        }
        .thumbnail-text {
            color : $color-primary;
        }
        &-vertical {
            text-align : center;
            .round-image {
                margin-bottom : 10px;
            }
        }
        &-horizontal {
            display : inline-block;
            .round-image {
                margin-right : 10px;
            }
            .thumbnail-text {
                display        : inline-block;
                vertical-align : middle;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// main.vue?801f38a4